import BFontAscMap from "./b_font_asc_map.js";
import BFontAsc8 from "./b_font_asc_8.js";
import BFontAsc10 from "./b_font_asc_10.js";
import BFontAsc12 from "./b_font_asc_12.js";
import BFontAsc16 from "./b_font_asc_16.js";

export default class BFontAscUtil {
  // 字符数量
  static charCount = 95;

  // 获取某个字符的位置索引
  static getCharIndex (ch) {
    let charIndex = 0;

    let charCode = ch.charCodeAt(0);
    let charPosition = 0;

    for (let i = 0; i < this.charCount; i++) {
      charPosition = BFontAscMap.b_font_asc_map[i];
      if (charPosition == charCode) {
        charIndex = i;
        break;
      }
    }
    return charIndex;
  }

  // 获取某个字符的像素数据
  static getCharPixels (ch, size) {
    let use_size = parseInt(size / 2);
    if (size <= 16) {
      use_size = 8;
    } else if (size <= 32) {
      use_size = 16;
    }

    let pixels = [];
    for (let y = 0; y < size; y++) {
      let rowPixels = [];
      for (let x = 0; x < use_size; x++) {
        rowPixels.push(0);
      }
      pixels.push(rowPixels);
    }
    // console.warn(pixels);

    let ch_bytes = size * parseInt(use_size / 8);
    let index = this.getCharIndex(ch);

    for (let i = 0; i < ch_bytes; i++) {
      let ch_bytes_content = 0x00;
      if (size == 8) {
        ch_bytes_content = BFontAsc8.b_font_asc_8[index * ch_bytes + i + 0];
      } else if (size == 10) {
        ch_bytes_content = BFontAsc10.b_font_asc_10[index * ch_bytes + i + 0];
      } else if (size == 12) {
        ch_bytes_content = BFontAsc12.b_font_asc_12[index * ch_bytes + i + 0];
      } else if (size == 16) {
        ch_bytes_content = BFontAsc16.b_font_asc_16[index * ch_bytes + i + 0];
      } else if (size == 24) {
        ch_bytes_content = BFontAsc24.b_font_asc_24[index * ch_bytes + i + 0];
      }

      for (let j = 0; j < 8; j++) {
        let targetX = (i * 8 + j) % use_size;
        let targetY = parseInt(8 * i / use_size);
        // if (targetX >= 4)
        // {
        //   targetX -= 4;
        // }
        // else if (targetX < 4)
        // {
        //   targetX += 4;
        // }
        // targetX -= 4;
        // targetX = 8 - targetX;
        // if (size == 12)
        // {
        //   targetX -= 1;
        //   targetY += 1;
        // }
        // else if (size == 16)
        // {
        //   targetX -= 1;
        //   targetY += 2;
        // }

        let b = (ch_bytes_content & (0x1 << (7 - j))) >> (7 - j);
        // if (b == 1) {
        //   // *(pixels + targetY * use_size + targetX) = 1;
        //   row.add(1);
        // } else {
        //   row.add(0);
        // }
        pixels[targetY][targetX] = b;
      }
      // pixels.add(row);
    }

    return pixels;
  }

  // 打印字符图形
  static printChar (ch, size) {
    let pixels = this.getCharPixels(ch, size);
    let i = 0;
    pixels.forEach((row) => {
      let rowStr = "";
      
      row.forEach((col) => {
        if (col > 0) {
          rowStr += "🍎";
        } else {
          rowStr += "🍏";
        }
      })
      i++;
      console.log(rowStr + " " + i);
      
    })
  }
}


// BFontAscUtil.printChar("8", 16);